import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import clsx from 'clsx';
import {
  Button,
  Card,
  Container,
  makeStyles
} from '@material-ui/core';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import FormControl from '@material-ui/core/FormControl';
import Footer from '../footer/Footer';
import Logo from '../../img/LOGO_GMI_aero.png';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: 'var(--gmi-color)',
    display: "flex",
    justifyContent: "center",
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: '0',
    left: '0'
  },
  card: {
    textAlign: 'center',
    alignSelf: 'center',
    margin: '20px 30px',
    padding: '50px',
    [theme.breakpoints.down('xs')]: {
      padding: '15px',
      margin: '10px'
    }
  },
  logo: {
    maxWidth: '100%',
    marginTop: '10px',
    width: 350,
    [theme.breakpoints.down('xs')]: {
      maxWidth: '90%',
    }
  },
  title: {
    color: 'var(--gmi-color)'
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 20,
    height: "100%"
  },
  formEl: {
    marginTop: 20
  },
  text: {
    fontSize: '0.7em',
    color: 'var(--gmi-color)'
  },
  errorMsg: {
    color: 'red',
    border: '1px solid red',
    padding: '10px'
  },
  loginBtn: {
    backgroundColor: 'var(--gmi-color)',
    "&:hover": {
      backgroundColor: '#113e78ec'
    },
    color: 'white',
    marginTop: 30
  }
}));

const LoginAdmin = ({ className, ...rest }) => {
  const classes = useStyles();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [token, setToken] = useState('');
  const history = useHistory();

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  
  const handleSubmit = (e) => {
    axios
      /* POST URL TO BE UPDATED */
      .post('/admin/auth', { email: email, password: password })
      .then((result) => {
        setToken(result.data);
        localStorage.setItem('auth', JSON.stringify(result.data));
      })
      .catch(err => {
        if (err) {
          setError(true);
        } else {
          setError(false);
        }
      });
  };

  token && history.push('/app/admin/dashboard');

  return (
    <div className={classes.root}>
      <Card
        className={clsx(classes.card, className)}
        elevation={2}
        {...rest}
      >
        <img className={classes.logo} src={Logo} alt="GMI-Logo" />
        <h1 className={classes.title}>Administrator</h1>
        <Container maxWidth="sm" style={{padding: 0}}>

          {error && (
            <span className={classes.errorMsg}>
              Unknown username or password
            </span>
          )}

          <form className={classes.cardContent} autoComplete="off" onSubmit={handleSubmit}>
            <FormControl className={classes.formEl} variant="outlined">
              <InputLabel htmlFor="email">Username</InputLabel>
              <OutlinedInput
                id="email"
                label="Username"
                variant="outlined"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
              />
            </FormControl>

            <FormControl className={classes.formEl} variant="outlined">
              <InputLabel htmlFor="password">Password</InputLabel>
              <OutlinedInput
                id="password"
                label="Password"
                variant="outlined"
                type={showPassword ? 'text' : 'password'}
                onChange={(e) => setPassword(e.target.value)}
                value={password}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                      >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>

            <Button className={classes.loginBtn} onClick={() =>history.push('/admin/dashboard')}>
              Log In
            </Button>
            <p className={classes.text}>
              {'Password forgotten? Contact GMI'}
            </p>
          </form>
        </Container>
      </Card>
      <Footer type="login"/>
    </div>
  )
}

export default LoginAdmin;
